import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const TemplateContainer = styled.div`
  max-width: 100vw !important;
  position: relative;
  overflow: hidden;

  & > div.gatsby-image-wrapper {
    position: relative;
    left: -5px;
    width: calc(100% + 10px);
  }
`

export const TemplateTitle = styled.div`
  margin-bottom: 80px;
  position: relative;
  max-width: 850px;
  margin: 0px auto;
`

export const TemplateImage = styled.div`
  display: grid;
  max-width: 960px;
  box-sizing: border-box;
  padding: 24px;
  margin: 0rem auto 3rem;
  max-height: 536px;
  overflow: hidden;

  & > div {
    width: 100%;
  }

  @media all and (max-width: ${layout.sm}) {
    padding: 24px 0px;
  }
`

export const TemplateHeadlineTitle = styled.div`
  max-width: 1260px;
  box-sizing: border-box;
  padding: 0rem 4rem;
  margin: 0px auto;

  @media all and (max-width: ${layout.md}) {
    padding: 0rem 1.5rem;
  }
`

export const TemplateBody = styled.div`
  margin: 46px auto 0px;
  position: relative;
  max-width: 976px;
  padding: 0rem 1.5rem;

  @media all and (max-width: ${layout.subLg}) {
    padding: 0rem 2rem;
  }
  @media all and (max-width: ${layout.xs}) {
    padding: 0rem 1rem;
  }
`

export const TemplateAction = styled.div`
  display: grid;
  margin: 3rem 0rem;
`

export const TemplateContent = styled.div`
  max-width: 712px;
  margin: 0px auto;

  @media all and (max-width: ${layout.md}) {
    max-width: 100%;
  }

  p {
    font-size: 1.2rem;
    font-weight: 300;
    line-height: 1.7;
    margin: .5em 0em;
    -webkit-font-smoothing: antialiased;

    @media all and (max-width: ${layout.sm}) {
      font-size: 1rem;
    }

    &.center {
      text-align: center;
      margin-bottom: 2rem;
    }
  }

  a {
    text-decoration: none;
    color: ${palette.snowFlower};

    &.button{
      background: ${palette.snowFlower};
      color: ${palette.white};
      min-width: 256px;
      padding: 11px 20px 13px;
      border-radius: 4px;
      font-weight: 500;
      justify-self: center;
      position: relative;
      top: 0.5rem;
    }
  }

  h2 {
    font-size: 2.5em;
    line-height: 1.4;
    margin: 0;
    padding-top: 24px;
    font-family: 'Walsheim';
  }

  h3 {
    font-size: 2em;
    line-height: 1.4;
    margin: 0;
    padding-top: 24px;
    font-family: 'Walsheim';
  }

  h4 {
    font-size: 1.5em;
    line-height: 1.4;
    margin: 0;
    font-family: 'Walsheim';
    padding-top: 24px;
  }

  ul, ol {
    margin-bottom: 0px;
    margin-left: 30px;

    li {
      margin-bottom: 20px;
      font-size: 1.2em;
      font-weight: 300;
      line-height: 1.7;
      -webkit-font-smoothing: antialiased;
    }
  }

  ul {
    list-style-type: disc;
  }

  img {
    position: relative;
    width: calc(100% + 100px);
    left: -50px;

    @media all and (max-width: ${layout.subLg}) {
      width: calc(100%);
      left: 0px;
    }
  }
`

export const MoreStoriesContainer = styled.div`
  padding-top: 40px;

  @media all and (min-width: ${layout.subLg}) {
    padding-top: 80px;
  }
`

export const CaseStudiesFooter = styled.div`
  position: fixed;
  z-index: 100;
  max-width: 100% !important;
  width: 100%;
  left: 0;
  bottom: 0;
  padding: 0;
  background-color: ${palette.cream};
  box-sizing: border-box;
  padding: 1.5rem 1.5rem 2.2rem;
  display: flex;
  align-items: center;
  justify-content: center;

  @media all and (max-width: ${layout.subMd}) {
    padding: 0;
  }

  & > h1 {
    font-weight: 600;

    @media all and (max-width: ${layout.subMd}) {
      display: none;
    }
  }

  & > a {
    margin-left: 1.6rem;
    min-width: 276px;

    @media all and (max-width: ${layout.subMd}) {
      width: 100%;
      margin: 0;
      border-radius: 0;
      padding: 1rem 1rem 1.2rem;
    }
  }
`

export const CaseStudiesFooterContent = styled.div``
